import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import React, { useState } from "react";
import Styles from "./AddAdmin.module.css";
import TextInput from "../../../../commons/Inputs/TextInput/TextInput";
import SelectInput from "../../../../commons/Inputs/Select/SelectInput";
import {
  handleAddUser_Admin,
  handleUpdateUser_Admin,
} from "../../../../Services/GNA/AlterApi";
import {
  ErrorMessage,
  SuccessMessage,
} from "../../../../commons/Toast/ErrorMessage";
import { id } from "date-fns/locale";

let userTypes = [
  {
    id: 1,
    name: "Admin",
    value: "ADMIN",
  },
  // {
  //   id: 2,
  //   name: "Maker",
  //   value: "MAKER",
  // },
  // {
  //   id: 3,
  //   name: "Checker",
  //   value: "CHECKER",
  // },
];

const AddAdmin = ({ open, handleClose, handleFetchAdmins, editData }) => {
  const [formData, setFormData] = useState({
    name: editData?.fullName || "",
    email: editData?.email || "",
    username: editData?.userName || "",
    userType:
      userTypes?.filter((ele) => ele?.value === editData?.userType)?.[0] || {},
    phone: editData?.phone || "",
    password: "",
  });
  const [errors, setErrors] = useState({
    email: "",
  });

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@gna\.energy$/;
    if (!email) return "Email is required";
    if (!emailRegex.test(email)) return "Invalid email format";
    return "";
  };

  const handleFormData = (field, value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [field]: value,
    }));
    if (field === "email") {
      const emailError = validateEmail(value);
      setErrors((prev) => ({
        ...prev,
        email: emailError,
      }));
    }
  };

  const handleSubmit = async () => {
    const emailError = validateEmail(formData?.email);
    if (emailError) {
      ErrorMessage("Please enter a valid @gna.energy email address.");
      return;
    }
    let payload = {
      email: formData?.email,
      phone: formData?.phone,
      userName: formData?.username,
      password: formData?.password,
      fullName: formData?.name,
      accountStatus: "VERIFIED",
      roles: [formData?.userType?.value],
      isInterstate: true,
      userType: formData?.userType?.value,
    };

    let res = await handleAddUser_Admin(payload);
    if (res?.data?.code === 200) {
      SuccessMessage(res?.data?.message);
      handleFetchAdmins();
      handleClose();
    } else {
      ErrorMessage(res?.data?.error || res?.data?.message);
    }
  };

  const handleUpdate = async () => {
    let payload = {
      userId: editData?.userId,
      phone: formData?.phone,
      fullName: formData?.name,
      accountStatus: "VERIFIED",
      roles: [formData?.userType?.value],
      isInterstate: true,
      userType: formData?.userType?.value,
    };

    let res = await handleUpdateUser_Admin(payload);
    if (res?.data?.code === 200) {
      SuccessMessage(res?.data?.message);
      handleFetchAdmins();
      handleClose();
    } else {
      ErrorMessage(res?.data?.error);
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={`popupModal ${Styles.addModalContainer}`}>
        <div className={`display_flex_row modalHeading ${Styles.headingText}`}>
          <div className={`headingText ${Styles.finalHead}`}>Add Admin</div>
          <Close
            style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
            onClick={handleClose}
          />
        </div>
        <div className={Styles.addElementCont}>
          <div>
            <TextInput
              heading={"Full name"}
              value={formData?.name}
              onChange={(e) => handleFormData("name", e)}
              example={"Eg. Admin 1"}
            />
          </div>
          <div>
            <TextInput
              heading={"Username"}
              value={formData?.username}
              onChange={(e) => handleFormData("username", e)}
              example={"Eg. admin1"}
              disabled={editData ? true : false}
            />
          </div>
          <div>
            <TextInput
              heading={"Email"}
              value={formData?.email}
              onChange={(e) => handleFormData("email", e)}
              example={"Eg. admmin@gna.energy"}
              disabled={editData ? true : false}
              error={errors.email}
              showErrorMessage={false}
            />
          </div>
          <div>
            <TextInput
              heading={"Phone"}
              value={formData?.phone}
              onChange={(e) => handleFormData("phone", e)}
              example={"Eg. 9876545672"}
            />
          </div>
          {!editData && (
            <div>
              <TextInput
                heading={"Password"}
                value={formData?.password}
                onChange={(e) => handleFormData("password", e)}
                example={"Eg. password"}
              />
            </div>
          )}
          <div>
            <SelectInput
              list={userTypes}
              value={formData?.userType}
              onChange={(val) => handleFormData("userType", val)}
              heading={"User Type"}
              example={"Select User Type"}
            />
          </div>
          <div
            className={Styles.submitButton}
            onClick={() => (editData ? handleUpdate() : handleSubmit())}
          >
            {editData ? "Update" : "Submit"}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddAdmin;
